import { useMediaQuery } from "../useMediaQuery";

export type UseScreenSizeResult = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

export type Breakpoints = {
  mobile?: string;
  tablet?: string;
  desktop?: string;
};

const useScreenSize = (breakpoints?: Breakpoints): UseScreenSizeResult => {
  const isMobile = useMediaQuery({ query: breakpoints?.mobile ?? "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: breakpoints?.tablet ?? "(min-width: 768px) and (max-width: 1023px)"
  });
  const isDesktop = useMediaQuery({ query: breakpoints?.desktop ?? "(min-width: 1024px)" });

  return { isMobile, isTablet, isDesktop };
};

export default useScreenSize;
